var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.type === 'hyperlink')?_c('Hyperlink',{attrs:{"text":_vm.label,"clickHandler":() => _vm.handleScroll(),"small":_vm.small,"color":_vm.color}}):_c('TextButton',{attrs:{"plain":"","label":_vm.label,"color":_vm.color,"variant":_vm.small ? 'small' : 'large'},on:{"click":() => _vm.handleScroll()}})
}
var staticRenderFns = []

export { render, staticRenderFns }